export default __webpack_public_path__ + "static/media/success.72f02d82.wav";